module.exports = __webpack_public_path__ + "static/media/get-paid-rocklea.13b43778.png";